import React, { useEffect, useRef, useState } from 'react';
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import { homeeidpicksList, productDetails } from '../services/Product-service';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { formatPrice } from "../utils/formatPrice";

function Eid({showeidpicks,notShowTitle}) {
    const sliderRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [recentproductArr, setrecentproductArr] = useState([]);
    const [apiTitle, setApiTitle] = useState('');

    const desktopSlidesToShow = 5;
    const totalItems = Array.isArray(recentproductArr) ? recentproductArr.length : 0;
    const canGoPrev = currentSlide > 0;
    const canGoNext = currentSlide + desktopSlidesToShow < totalItems;

    var settings = {
        dots: false,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: Math.min(desktopSlidesToShow, totalItems || 1),
        slidesToScroll: totalItems > desktopSlidesToShow ? desktopSlidesToShow : 1,
        initialSlide: 0,
        beforeChange: (_old, next) => setCurrentSlide(next),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.min(desktopSlidesToShow, totalItems || 1),
                    slidesToScroll: totalItems > desktopSlidesToShow ? desktopSlidesToShow : 1,
                    arrows: false,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    infinite: false,
                    slidesToShow: Math.min(2, totalItems || 1),
                    slidesToScroll: totalItems > 2 ? 2 : 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    infinite: false,
                    slidesToShow: Math.min(2, totalItems || 1),
                    slidesToScroll: totalItems > 2 ? 2 : 1
                }
            }
        ]
    };
    const getrecentproductList = async () => {

        await homeeidpicksList().then((data) => {
            setrecentproductArr(data.data);
            setApiTitle(data?.section_ttile || data?.section_title || '');
        }).catch((error) => {
            console.error("Error fetching data list:", error);
        })
    }

    useEffect(() => {
        if (!showeidpicks) return;
        getrecentproductList();
    }, [showeidpicks])

    const [lowestPrices, setLowestPrices] = useState({});

    useEffect(() => {
        if (!recentproductArr || recentproductArr.length === 0) return;

        recentproductArr.forEach((product) => {
            const prodId = product.id;
            if (prodId && lowestPrices[prodId] === undefined) {
                setLowestPrices((prev) => ({ ...prev, [prodId]: null }));

                productDetails(prodId)
                    .then((data) => {
                        if (data && data.productvariants && data.productvariants.length > 0) {
                            const sizeOrder = ['3xs', 'xxs', 'xs', 's', 'm', 'l', 'xl', '2xl', 'xxl', '3xl', 'xxxl', '4xl', '5xl', '6xl'];
                            const sortedVars = [...data.productvariants].sort((a, b) => {
                                const sizeA = (a.size || '').toLowerCase().trim();
                                const sizeB = (b.size || '').toLowerCase().trim();
                                const indexA = sizeOrder.indexOf(sizeA);
                                const indexB = sizeOrder.indexOf(sizeB);
                                if (indexA === -1 && indexB === -1) return 0;
                                if (indexA === -1) return 1;
                                if (indexB === -1) return -1;
                                return indexA - indexB;
                            });
                            const lowestVariant = sortedVars[0];
                            if (lowestVariant) {
                                setLowestPrices((prev) => ({
                                    ...prev,
                                    [prodId]: {
                                        price: Number(lowestVariant.price) || 0,
                                        saleprice: Number(lowestVariant.saleprice) || 0
                                    }
                                }));
                            } else {
                                setLowestPrices((prev) => ({
                                    ...prev,
                                    [prodId]: {
                                        price: Number(product.price) || 0,
                                        saleprice: Number(product.saleprice) || 0
                                    }
                                }));
                            }
                        } else {
                            setLowestPrices((prev) => ({
                                ...prev,
                                [prodId]: {
                                    price: Number(product.price) || 0,
                                    saleprice: Number(product.saleprice) || 0
                                }
                            }));
                        }
                    })
                    .catch((err) => {
                        console.error(`Error fetching lowest price for product ${prodId}`, err);
                        setLowestPrices((prev) => ({
                            ...prev,
                            [prodId]: {
                                price: Number(product.price) || 0,
                                saleprice: Number(product.saleprice) || 0
                            }
                        }));
                    });
            }
        });
    }, [recentproductArr]);

    return (
        showeidpicks && (
        <div>
            <div className='App'>
                <div className="BreakPointContainer">
                    {!notShowTitle &&(
                    <div className="layout row justify-space-between align-center text-left SectionTitle">
                        <h1 className='m-t-0 m-b-0 w-auto'> {apiTitle || 'EID PICKS'} </h1>
                        <Link to="/category" className='ViewAllUrlsLink orat-color-hover h5 demi-bold w-auto'>VIEW ALL</Link>
                    </div>
                    )}
                    <div className="slider-container">
                        <button
                            type="button"
                            data-role="none"
                            className={`slick-arrow slick-prev${canGoPrev ? '' : ' slick-disabled'}`}
                            style={{ display: 'block' }}
                            aria-disabled={!canGoPrev}
                            onClick={() => canGoPrev && sliderRef.current?.slickPrev()}
                        />
                        <Slider ref={sliderRef} key={Object.keys(lowestPrices).length} {...settings}>
                            {recentproductArr?.map((data, index) => (
                                <div className='item' key={index}>
                                    <div className="CarouselSection product">
                                        <div className="prel Gutter">
                                            <Link to={`/products/productdetails/${data.id}`} >
                                                <div className="DynamicHeightLoaderWrapper" style={{ paddingTop: '130%', overflow: 'hidden' }}>
                                                    <div className="DynamicHeightLoader layout row align-center justify-center" style={{ paddingTop: '20%' }}>
                                                        <img src={data.product_thumbail} alt={data.product_title} className='img-resp DynamicHeightLoaderImage' style={{ padding: '0px', bottom: 'inherit' }} />
                                                    </div>
                                                    <div className="animated-bg-placeholder"></div>
                                                </div>
                                                {/* <div className="image-gradient"></div> */}
                                                <div className="ImageTextDetail ProductImageTextDetail">
                                                    <label className="ellipsis h5 ImageTextLabelTop m-t-5 demi-bold"> {data.product_title} </label>
                                                    <label className="h6 ellipsis-two-line font-normal ImageTextLabelBottom block font-normal">{data.product_short_description}</label>
                                                    <div className="ProductPrice layout row wrap">
                                                             {(() => {
                                                                 const lowestInfo = lowestPrices[data.id];
                                                                 const finalPrice = lowestInfo 
                                                                     ? (lowestInfo.saleprice > 0 ? lowestInfo.saleprice : lowestInfo.price)
                                                                     : (data?.saleprice > 0 ? data.saleprice : data.price);
                                                                 return (
                                                                      <span className='SpecialPrice p2 demi-bold w-auto p-0 eid-pick-price-unique' style={{ marginLeft: '4%' }}>
                                                                          ₹{formatPrice(finalPrice, { showSymbol: false })}
                                                                      </span>
                                                                  );
                                                              })()}
                                                            {data?.discount_amount>0 && ( <span className='InitialPrice p3 w-auto p-0'> ₹{formatPrice(data?.price, { showSymbol: false })} </span>)}
                                                            <span className='DiscountPriceRound p3 w-auto p-0'> 
                                                            {data?.discount_type=='flat'? `${data?.discount_amount} FLAT OFF`:''} 
                                                            {data?.discount_type=='percentage'? `${data?.discount_amount}% OFF`:''} </span>
                                                        </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </Slider>
                        <button
                            type="button"
                            data-role="none"
                            className={`slick-arrow slick-next${canGoNext ? '' : ' slick-disabled'}`}
                            style={{ display: 'block' }}
                            aria-disabled={!canGoNext}
                            onClick={() => canGoNext && sliderRef.current?.slickNext()}
                        />
                    </div>


                </div>
            </div>
        </div>
        )
    )
}

export default Eid